"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTabTitle = exports.generateTabIds = void 0;

var _react = _interopRequireDefault(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _sbTab = require("./sb-tab");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-prototype-builtins */

/*
The first layer of children gets (not injected) their own generated ID, when tabId is not present.
 */
var generateTabIds = function generateTabIds(_ref) {
  var tabs = _ref.tabs,
      namespace = _ref.namespace;
  var result = [];

  _react.default.Children.forEach(tabs, function (tab) {
    if (tab) {
      var _tab$props;

      var tabId = (_tab$props = tab.props) === null || _tab$props === void 0 ? void 0 : _tab$props.tabId;

      if (tabId) {
        result.push(tabId);
      } else {
        result.push(namespace ? "".concat(namespace, "-").concat((0, _v.default)()) : (0, _v.default)());
      }
    }
  });

  return result;
};
/*
Extracts the SbTab.TabTitle from the SbTab children to render it differently.
 */


exports.generateTabIds = generateTabIds;

var getTabTitle = function getTabTitle(children) {
  var tabTitleComponent = '';
  var restChildren = [];

  _react.default.Children.forEach(children, function (child) {
    if ((child === null || child === void 0 ? void 0 : child.type) && (_sbTab.SbTab.Title.isPrototypeOf(child.type) || child.type === _sbTab.SbTab.Title)) {
      tabTitleComponent = child;
    } else {
      restChildren.push(child);
    }
  });

  return {
    tabTitleComponent: tabTitleComponent,
    restChildren: restChildren
  };
};

exports.getTabTitle = getTabTitle;
//# sourceMappingURL=utils.js.map